export const PAY_MODE = {
  MONTH: 5,
  WEEK: 12,
  DAY: 10,
}

export const payModeList = {
  [PAY_MODE.MONTH]: '月结',
  [PAY_MODE.WEEK]: '周结',
  [PAY_MODE.DAY]: '日结',
}

export const PAY_PLANT_TYPE = {
  FIXED: 0,
  DYNAMIC: 3,
}

export const payPlanTypeList = {
  [PAY_PLANT_TYPE.FIXED]: '固定金额',
  [PAY_PLANT_TYPE.DYNAMIC]: '动态金额',
}

export const COMMISSION_TYPE = {
  BASE: 1,
  LOWER: 2,
}

export const RENT_AMOUNT_TYPE = {
  EACH_PERIOD: 1,
  DAY: 2,
}

export const PLANT_AMOUNT_TYPE = {
  EACH_PERIOD: 1,
  DAY: 2,
}

export const commissionTypeList = {
  [COMMISSION_TYPE.BASE]: '当期支付总金额',
  [COMMISSION_TYPE.LOWER]: '当期支付总金额-动态规则下限',
}

export const RENT_PERIOD_TYPE = {
  DAY: 1,
  MONTH: 3,
}

export const rentPeriodTypeList = {
  [RENT_PERIOD_TYPE.DAY]: '天',
  [RENT_PERIOD_TYPE.MONTH]: '个月',
}
